<header class="header-modern">
    <!-- Top Bar -->
    <div class="top-header">
        <div class="top-header-container">
            <!-- Lado izquierdo (opcional: fecha, teléfono, etc.) -->
            <div class="top-header-left">
                <span class="header-info">
                <i class="bi bi-geo-alt-fill"></i> Nuevo Laredo, Tamaulipas
                </span>
                <span class="header-info">
                    
                    <div class="social-links">
                        <a href="https://www.facebook.com/gobiernodenuevolaredo" class="social-link" target="_blank" rel="noopener">
                            <i class="bi bi-facebook"></i>
                        </a>
                        <a href="https://x.com/Gob_NuevoLaredo" target="_blank" class="social-link">
                            <i class="bi bi-twitter-x"></i>
                        </a>
                    </div>
                </span>
            </div>
    
            <!-- Lado derecho con botón Directorio -->
            <div class="top-header-right">
                <a [routerLink]="['varios']" [queryParams]="{id: 'directorio'}" class="btn-directorio">
                    <i class="bi bi-person-lines-fill"></i>
                    Directorio Telefónico Gubernamental
                </a>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="nav-content">
            <div class="logo-container header-logo">
                <a routerLink="/">
                        <img src="https://nld.gob.mx/assets/logos/logonld.png" alt="Gobierno de Nuevo Laredo" class="logo-modern">
                </a>
               
            </div>

            <ul class="nav-menu-modern" [ngClass]="{'mobile-open': isMenuOpen}">
                <li><a routerLink="/" class="nav-link-modern" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}" (click)="toggleMenu()">Inicio</a></li>
                <li><a routerLink="/mensaje" class="nav-link-modern" routerLinkActive="active"
                        (click)="toggleMenu()">Presidenta</a></li>
                <li><a routerLink="/cabildo" class="nav-link-modern" routerLinkActive="active"
                        (click)="toggleMenu()">Cabildo</a></li>
              <!---->  <li><a [routerLink]="['/varios']" [queryParams]="{id: 'organigrama'}" class="nav-link-modern" routerLinkActive="active" 
                        (click)="toggleMenu()">Dependencias Municipales</a></li>
                <li><a [routerLink]="['/noticias']" [queryParams]="{id: '0'}" class="nav-link-modern" routerLinkActive="active"
                        (click)="toggleMenu()">Sala de Prensa</a></li>
                <li><a routerLink="/transparencia" class="nav-link-modern" routerLinkActive="active"
                        (click)="toggleMenu()">Transparencia</a></li>
               
                <li>
                    <!--href="http://201.144.104.26/nldretys/"-->
                    <a  (click)="irATramites()" target="_blank" style="cursor: pointer;" class="btn-predial-modern">
                        <i class="bi bi-people"></i>
                        Trámites y Servicios
                    </a>
                    
                </li>
            </ul>

            <button class="hamburger-modern" [ngClass]="{'active': isMenuOpen}" (click)="toggleMenu()">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </div>
    </div>
</header>